// BACnet engineering units arrive as names (`degrees-celsius`); show symbols.
const SYMBOLS: Record<string, string> = {
  'no-units': '',
  'degrees-celsius': '°C',
  'degrees-fahrenheit': '°F',
  'degrees-kelvin': 'K',
  'delta-degrees-kelvin': 'K',
  percent: '%',
  'percent-relative-humidity': '%rH',
  pascals: 'Pa',
  kilopascals: 'kPa',
  bars: 'bar',
  'parts-per-million': 'ppm',
  watts: 'W',
  kilowatts: 'kW',
  megawatts: 'MW',
  'watt-hours': 'Wh',
  'kilowatt-hours': 'kWh',
  'megawatt-hours': 'MWh',
  'cubic-meters': 'm³',
  'cubic-meters-per-hour': 'm³/h',
  'cubic-meters-per-second': 'm³/s',
  'liters-per-second': 'l/s',
  'liters-per-hour': 'l/h',
  'meters-per-second': 'm/s',
  volts: 'V',
  amperes: 'A',
  hertz: 'Hz',
  luxes: 'lx',
  seconds: 's',
  minutes: 'min',
  hours: 'h',
};

/** Display symbol for a unit name; unknown names are shown as they are. */
export function unitSymbol(unit: string | null | undefined): string {
  if (!unit) return '';
  return SYMBOLS[unit] ?? unit;
}
